import { Stack } from '@mui/material'
import { LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'

export default function AssetValuationListLoading() {
    return (
        <PageGridContainer>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="column" gap={tokens.SizingSpacing300}>
                    <Stack direction="row" gap={tokens.SizingSpacing150} alignItems="center" justifyContent="flex-end">
                        <LoadingSkeleton variant="rounded" height="32px" width="77px" />
                        <LoadingSkeleton variant="rounded" height="32px" width="134px" />
                        <LoadingSkeleton variant="rounded" height="32px" width="114px" />
                        <LoadingSkeleton variant="rounded" height="56px" width="167px" />
                    </Stack>

                    <Stack direction="column" gap={tokens.SizingSpacing100}>
                        <LoadingSkeleton variant="rounded" height="70px" width="100%" count={3} />
                    </Stack>
                </Stack>
            </PageGridItem>
        </PageGridContainer>
    )
}
